// removed by extract-text-webpack-plugin
module.exports = {"menu":"_8c1abf85","menu--small":"_8b7133c9","menu--medium":"_78e014b5","menu--large":"_376e49b9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/PopoverMenu/index.styl
// module id = 5216
// module chunks = 39